import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/@resources/services/local-storage.service';
import { SeoService } from '../../@resources/services/SEO.service';
@Component({
  selector: 'app-health-education',
  templateUrl: './health-education.component.html',
  styleUrls: ['./health-education.component.scss']
})
export class HealthEducationComponent implements OnInit {

  constructor(
    private readonly seoService: SeoService,
    private localStorage: LocalStorageService,
  ) { }

  ngOnInit(): void {
    this.setTitle();
  }
  setTitle() {
    const lang = this.localStorage.get('lang')
    lang == 'en' ? this.seoService.updateTitle('Health education') : this.seoService.updateTitle('التثقيف الصحي');  
  }
}
